import { getOperatorInfo } from 'src/common/services/app';
import {
  deleteBudgetAdjustment,
  getBudgetAdjustList,
  getBudgetAdjustmentInfo,
  saveBudgetAdjustment,
} from '../services';

export default {
  namespace: 'budgetAdjust',
  state: {},
  effects: {
    // 查询调整申请单列表
    *getBudgetAdjustList({ payload }, { call }) {
      return yield call(getBudgetAdjustList, payload);
    },

    // 获取经办人所在部门
    *getOperatorInfo({ payload }, { call }) {
      return yield call(getOperatorInfo, payload);
    },

    // 查询调整申请单
    *getBudgetAdjustmentInfo({ payload }, { call }) {
      return yield call(getBudgetAdjustmentInfo, payload);
    },

    // 删除调整申请单
    *deleteBudgetAdjustment({ payload }, { call }) {
      return yield call(deleteBudgetAdjustment, payload);
    },

    // 添加预算调整申请单
    *saveBudgetAdjustment({ payload }, { call }) {
      return yield call(saveBudgetAdjustment, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
